import $ from 'jquery';
import { GridView } from '@component/product-pool-media';
import ItemView from './ContentThumbnailView';
import TitleView from './ContentTitleView';

module.exports = GridView.extend({
  onRender() {
    $('<div class="contentContainer"></div>').insertAfter(this.$el.find('.product-pool-media-container .poolHeader'));
    this.$el.find('.contentContainer').prepend('<div class="contentGrid"></div>');
    this.$el.find('.contentContainer').prepend('<div class="contentThumb"></div>');
    this.$el.find('.contentGrid').prepend($(this.$('.product-pool-media-grid')[0]).addClass('showContent'));
    $('<div class="contentThumbTitle"></div>').insertAfter(this.$el.find('.product-pool-media-container .poolHeader'));
    this.$el.find('.contentContainer').addClass('noPrice');
    this.$el.find('.contentContainer .contentGrid .productThumbnail .productDetail .productDescription').hide();
    new ItemView({ el: this.$el.find('.contentThumb'), model: this.model, config: this.options.config }).render();
    new TitleView({ el: this.$el.find('.contentThumbTitle'), model: this.model, config: this.options.config }).render();

    // Adding a class specifically to handle situation where KS is ON but rto returns no content (due to an error or being in control)
    $(this.$('.product-pool-media-grid')[0]).addClass('showContent');
  },
});
